"use client"

import { Mobile, PC, Tablet, Notebook } from "../../views/ReactiveMode"
import { useEffect } from "react"
import { Link } from "react-router-dom"
import {addScrollAnimation} from "../../styles/animation";

function TreeBoxContents() {
    useEffect(() => {
        addScrollAnimation()
    }, [])

    const boxItems = [
        {
            title: "예배시간",
            subTitle: "함께 드리는 예배",
            url: "/worship-information",
            icon: "fas fa-clock",
            color: "#d4b8ff", // 파스텔 보라색
        },
        {
            title: "오시는길",
            subTitle: "교회 찾아오시는 방법",
            url: "/directions",
            icon: "fas fa-map-marker-alt",
            color: "#a5c8ff", // 파스텔 파란색
        },
        {
            title: "교회소식",
            subTitle: "최신 교회 소식과 공지사항",
            url: "/church-news",
            icon: "fas fa-newspaper",
            color: "#ffc8a2", // 파스텔 주황색
        },
        {
            title: "새신자",
            subTitle: "처음 오신 분들을 위한 안내",
            url: "/new-family-information",
            icon: "fas fa-hands-helping",
            color: "#a8e6cf", // 파스텔 초록색
        },
    ]

    const renderBoxItem = (item, index) => {
        const delay = `delay-${(index % 4) * 100}`

        return (
            <Link key={index} to={item.url} className={`info-box animate-on-scroll fade-in ${delay}`}>
                <div className="info-box-content">
                    <div className="info-box-icon" style={{ backgroundColor: item.color }}>
                        <i className={item.icon}></i>
                    </div>
                    <h3 className="info-box-title">{item.title}</h3>
                    <p className="info-box-subtitle">{item.subTitle}</p>
                </div>
            </Link>
        )
    }

    return (
        <>
            <PC>
                <section className="info-boxes-section">
                    <div className="info-boxes-container">
                        <div className="info-boxes-grid pc-grid">{boxItems.map((item, index) => renderBoxItem(item, index))}</div>
                    </div>
                </section>
            </PC>

            <Notebook>
                <section className="info-boxes-section">
                    <div className="info-boxes-container">
                        <div className="info-boxes-grid notebook-grid">
                            {boxItems.map((item, index) => renderBoxItem(item, index))}
                        </div>
                    </div>
                </section>
            </Notebook>

            <Tablet>
                <section className="info-boxes-section">
                    <div className="info-boxes-container">
                        <div className="info-boxes-grid tablet-grid">
                            {boxItems.map((item, index) => renderBoxItem(item, index))}
                        </div>
                    </div>
                </section>
            </Tablet>

            <Mobile>
                <section className="info-boxes-section">
                    <div className="info-boxes-container">
                        <div className="info-boxes-grid mobile-grid">
                            {boxItems.map((item, index) => renderBoxItem(item, index))}
                        </div>
                    </div>
                </section>
            </Mobile>
        </>
    )
}

export default TreeBoxContents
